import React, { useState, useEffect, useRef } from 'react'
import Layout from './Layout'
import './Style.css';
import { Link, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { convertNumberFrench, authHeader } from '../_helpers';
import { HiOutlineDownload } from 'react-icons/hi'
import moment from 'moment';
import PageLoaderComp from '../component/pageLoaderComp';
import { PageHeader, ResponsiveDataTable } from './Components';

export default function Factureanattente() {
    const currentUser = useSelector(state => state.authentication.user);
    const [pageLoading, setPageLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchQuery, setSearchQuery] = useState('');
    const [dateRange, setDateRange] = useState({ startDate: '', endDate: '' });

    const filterByDateRange = (start, end) => {
        getAllDevise(start, end);
    };

    const TabHead = [
        'Nom du client',
        'Formulaire',
        'Journal de diffusion',
        'Montant',
        'Date de création',
        'Facture',
        'Attestation',
    ]
    const [tabData, setTabData] = useState([]);
    const [totalRows, setTotalRows] = useState([]);
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabData.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const userData = (currentUser) => {
        // If user.data exists, use it; otherwise, use user directly
        return currentUser && currentUser.data ? currentUser.data : currentUser;
    };
    const user = userData(currentUser);
    const getAllDevise = async (startDate = '', endDate = '') => {
        try {
            setPageLoading(true);
            let url = `${process.env.REACT_APP_API_URL}api/announce/invoices/pending/${user?.id}`;
            
            // Add date parameters if they exist
            if (startDate || endDate) {
                url += '?';
                if (startDate) url += `from=${startDate}`;
                if (endDate) url += `${startDate ? '&' : ''}to=${endDate}`;
            }
            
            // console.log('Fetching from URL:', url);
            // console.log('User ID:', user?.id);
            // console.log('Date Range:', { startDate, endDate });
            
            const response = await fetch(url, {
                method: 'GET',
                headers: authHeader()
            });
            console.log('Response status:', response.status);
            
            if (!response.ok) {
                const errorText = await response.text();
                console.error('Error response:', errorText);
                throw new Error(`Network response was not ok: ${response.status} ${errorText}`);
            }
            
            const data = await response.json();
            //console.log('Received data:', data);
            
            if (data && data.data) {
                setTabData(data.data);
                setTotalRows(data.data);
            } else {
              //  console.error('Unexpected data format:', data);
                setTabData([]);
                setTotalRows([]);
            }
        } catch (error) {
          //  console.error('Error fetching data:', error);
            setTabData([]);
            setTotalRows([]);
        } finally {
            setPageLoading(false);
        }
    }
    const getAllDeviseRef = useRef(getAllDevise);
    useEffect(() => {
        window.scrollTo(0, 0)
        getAllDeviseRef.current();
    }, []);

    if (!currentUser) {
        return <Navigate to="/" />;
    }
    return (
        <>
        {pageLoading ?
        <PageLoaderComp />
        : ""}
        <Layout>
            <div className='mb-8 col-span-12 xl:col-span-9'>
                <div className='max-w-[1126px] w-full h-full bg-white rounded-[20px]'>
                    <PageHeader title="Facture en attente" />

                    <div className='mt-8 sm:px-9 px-4'>
                        <div className='mb-6 flex flex-wrap items-center gap-3'>
                            <span className="text-sm text-gray-600">Du</span>
                            <input 
                                type="date" 
                                className="px-3 py-2 border rounded-md text-sm" 
                                value={dateRange.startDate}
                                onChange={(e) => {
                                    const newStartDate = e.target.value;
                                    setDateRange(prev => ({ ...prev, startDate: newStartDate }));
                                    filterByDateRange(newStartDate, dateRange.endDate);
                                }}
                            />
                            <span className="text-sm text-gray-600">au</span>
                            <input 
                                type="date" 
                                className="px-3 py-2 border rounded-md text-sm" 
                                value={dateRange.endDate}
                                onChange={(e) => {
                                    const newEndDate = e.target.value;
                                    setDateRange(prev => ({ ...prev, endDate: newEndDate }));
                                    filterByDateRange(dateRange.startDate, newEndDate);
                                }}
                            />
                            <button 
                                className="px-3 py-2 text-sm bg-gray-100 rounded-md hover:bg-gray-200"
                                onClick={() => {
                                    setDateRange({ startDate: '', endDate: '' });
                                    filterByDateRange('', '');
                                }}
                            >
                                Réinitialiser
                            </button>
                        </div>

                        <ResponsiveDataTable
                            columns={[
                                {
                                    header: 'Nom du client',
                                    field: 'username',
                                    render: (item) => item.username,
                                },
                                {
                                    header: 'Formulaire',
                                    field: 'form_type',
                                    render: (item) => item.form_type,
                                    truncate: true,
                                },
                                {
                                    header: 'Journal de diffusion',
                                    field: 'journal_detail',
                                    render: (item) => item.journal_detail,
                                    truncate: true,
                                },
                                {
                                    header: 'Montant',
                                    render: (item) => <span className="font-semibold">{convertNumberFrench(item.total)} €</span>,
                                },
                                {
                                    header: 'Date de création',
                                    render: (item) => moment(item.creation_date).format("DD/MM/YYYY"),
                                },
                                {
                                    header: 'Facture',
                                    isAction: true,
                                    render: (item) => (
                                        <Link 
                                            target="_blank" 
                                            to={`${process.env.REACT_APP_AWS_URL_STATIC_BUSYPLACE}assets/uploads/pdfgenerate/invoice/${item.votre_pdf}`}
                                            className="p-2 hover:bg-gray-100 rounded-lg transition-colors inline-flex"
                                            title="Télécharger la facture"
                                        >
                                            <HiOutlineDownload className='w-5 h-5' />
                                        </Link>
                                    ),
                                },
                                {
                                    header: 'Attestation',
                                    isAction: true,
                                    render: (item) => (
                                        <Link 
                                            target="_blank" 
                                            to={`${process.env.REACT_APP_AWS_URL_STATIC_BUSYPLACE}assets/uploads/pdfgenerate/attestation/${item.attestation}`}
                                            className="p-2 hover:bg-gray-100 rounded-lg transition-colors inline-flex"
                                            title="Télécharger l'attestation"
                                        >
                                            <HiOutlineDownload className='w-5 h-5' />
                                        </Link>
                                    ),
                                },
                            ]}
                            data={tabData}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            renderActions={(item) => (
                                <div className="flex items-center gap-2 justify-center">
                                    <Link 
                                        target="_blank" 
                                        to={`${process.env.REACT_APP_AWS_URL_STATIC_BUSYPLACE}assets/uploads/pdfgenerate/invoice/${item.votre_pdf}`}
                                        className="p-2 hover:bg-gray-100 rounded-lg transition-colors flex items-center gap-1"
                                    >
                                        <HiOutlineDownload className='w-5 h-5' />
                                        <span className="text-xs">Facture</span>
                                    </Link>
                                    <Link 
                                        target="_blank" 
                                        to={`${process.env.REACT_APP_AWS_URL_STATIC_BUSYPLACE}assets/uploads/pdfgenerate/attestation/${item.attestation}`}
                                        className="p-2 hover:bg-gray-100 rounded-lg transition-colors flex items-center gap-1"
                                    >
                                        <HiOutlineDownload className='w-5 h-5' />
                                        <span className="text-xs">Attestation</span>
                                    </Link>
                                </div>
                            )}
                            emptyMessage="Aucune facture en attente"
                            keyField="id"
                        />
                    </div>
                </div>
            </div>
        </Layout >
        </>
    )
}

